import { post} from '@/util/utils';
import axios from 'axios';

function queryMachineWorkDetail(machineNumber) {
	return post('dashboard/queryMachineWorkDetail', {
		machineNumber: machineNumber
	});
}

function getEuipment(){
    const payload = {
        "appKey": "6c912613d53e6ce0",
        "sign": "M2Y4ZDlhM2ZkODE4MGVjNTU2YzAzMGM2MTY2NmFmNjdmNGY0OWU2ZmE2OWNmYTFkODFiMDkyZDM0MTdlNzczNQ==",
        "worksheetId": 'equ_list',
        "viewId": "",
        "pageSize": 1000,
        "pageIndex": 1,
      };
    const headers = {
        'Content-Type': 'application/json'
    }
    var response_data=axios.post('/api/v2/open/worksheet/getFilterRows', payload,{headers})
    return response_data;
}

export {getEuipment, queryMachineWorkDetail};
